export const safeJsonParse = (value, fallback = {}) => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === "object") return value;
  if (typeof value !== "string") return fallback;

  const attempts = [
    value,
    value.replace(/'/g, '"'),
    // duplica backslashes sueltos que rompen JSON.parse
    value.replace(/\\(?![\\/"bfnrtu])/g, "\\\\"),
  ];

  for (const candidate of attempts) {
    try {
      return JSON.parse(candidate);
    } catch {
      // intenta siguiente variante
    }
  }

  return fallback;
};
